import { configureStore } from '@reduxjs/toolkit'
import {
    authApi, AuthReducer, EmployeeApi, LeaveApi, OverTimeApi, EmployeeContractApi,
    payRollsApi, systemFlagApi, SalaryReducer, ProjectApi, holidayApi, HolidayReducer, ProjectReducer,
    SystemFlagReducer, DashboardApi, ReportsApi, AccountSettingsApi, LeavesSliceReducer, ResourcesApi, DeviceApi,
    BiometricApi, BiometricsReducer,
    AttendanceApi
} from 'pages'
import { DashboardUIReducer } from "layout"
import { masterDataApi } from './masterData'
import { getEmployeeRoleByIdApi } from './getEmployeeByRoleId'
import { getEmployeeByDesignationIdApi } from './getEmployeeByDesignationId'

const reducer = {
    [authApi.reducerPath]: authApi.reducer,
    [systemFlagApi.reducerPath]: systemFlagApi.reducer,
    AuthReducer: AuthReducer,
    DashboardUIReducer: DashboardUIReducer,
    [masterDataApi.reducerPath]: masterDataApi.reducer,
    [EmployeeApi.reducerPath]: EmployeeApi.reducer,
    [EmployeeContractApi.reducerPath]: EmployeeContractApi.reducer,
    [OverTimeApi.reducerPath]: OverTimeApi.reducer,
    [LeaveApi.reducerPath]: LeaveApi.reducer,
    [payRollsApi.reducerPath]: payRollsApi.reducer,
    [getEmployeeRoleByIdApi.reducerPath]: getEmployeeRoleByIdApi.reducer,
    SalaryReducer: SalaryReducer,
    [getEmployeeByDesignationIdApi.reducerPath]: getEmployeeByDesignationIdApi.reducer,
    [ProjectApi.reducerPath]: ProjectApi.reducer,
    [holidayApi.reducerPath]: holidayApi.reducer,
    [DashboardApi.reducerPath]: DashboardApi.reducer,
    [ReportsApi.reducerPath]: ReportsApi.reducer,
    [ResourcesApi.reducerPath]: ResourcesApi.reducer,
    [DeviceApi.reducerPath]: DeviceApi.reducer,
    [BiometricApi.reducerPath]: BiometricApi.reducer,
    [AttendanceApi.reducerPath]: AttendanceApi.reducer,
    HolidayReducer: HolidayReducer,
    ProjectReducer: ProjectReducer,
    SystemFlagReducer: SystemFlagReducer,
    LeavesSlice: LeavesSliceReducer,
    BiometricsReducer: BiometricsReducer,
    [AccountSettingsApi.reducerPath]: AccountSettingsApi.reducer,
}

const reducermiddleware = [
    authApi.middleware,
    systemFlagApi.middleware,
    masterDataApi.middleware,
    masterDataApi.middleware,
    EmployeeApi.middleware,
    EmployeeContractApi.middleware,
    OverTimeApi.middleware,
    LeaveApi.middleware,
    payRollsApi.middleware,
    getEmployeeRoleByIdApi.middleware,
    getEmployeeByDesignationIdApi.middleware,
    ProjectApi.middleware,
    holidayApi.middleware,
    DashboardApi.middleware,
    ReportsApi.middleware,
    ResourcesApi.middleware,
    AccountSettingsApi.middleware,
    DeviceApi.middleware,
    BiometricApi.middleware,
    AttendanceApi.middleware
]

if (process.env.NODE_ENV !== `production`) {
    const { logger } = require(`redux-logger`);
    reducermiddleware.push(logger);
}

const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([
        ...reducermiddleware
    ]),
    devTools: process.env.NODE_ENV !== 'production',
})

export default store

// Types
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
